<div class="nb-page" [class.nb-page--split]="selected">
  <div class="nb-card">
    <!-- Header -->
    <div class="nb-head">
      <div class="nb-head-title">
        <span class="nb-title">Notifications</span>
        @if (unreadCount > 0) {
          <span class="nb-pill">{{ unreadLabel }}</span>
        }
      </div>
      <div class="nb-head-actions">
        <div class="nb-menu-wrap">
          <button
            type="button"
            class="nb-icon-btn"
            aria-label="More actions"
            [attr.aria-expanded]="menuOpen"
            (click)="menuOpen = !menuOpen"
          >
            <i class="bx bx-dots-horizontal-rounded" aria-hidden="true"></i>
          </button>
          @if (menuOpen) {
            <div class="nb-menu" role="menu">
              <button
                type="button"
                role="menuitem"
                [disabled]="unreadCount === 0"
                (click)="markAllRead()"
              >
                Mark all as read
              </button>
              <a role="menuitem" routerLink="/main/notifications/preferences">
                Notification settings
              </a>
            </div>
          }
        </div>
        <a
          class="nb-icon-btn"
          routerLink="/main/notifications/preferences"
          aria-label="Notification settings"
        >
          <i class="bx bx-cog" aria-hidden="true"></i>
        </a>
      </div>
    </div>

    <!-- Filters -->
    <div class="nb-filters">
      @for (filter of filters; track filter.label) {
        <button
          type="button"
          class="nb-chip"
          [class.nb-chip--on]="filter === selectedFilter"
          [attr.aria-pressed]="filter === selectedFilter"
          (click)="selectFilter(filter)"
        >
          {{ filter.label }}
        </button>
      }
    </div>

    <!-- List -->
    @if (loading) {
      <div class="nb-list">
        @for (row of [1, 2, 3, 4, 5, 6]; track row) {
          <div class="nb-skeleton-row">
            <span class="nb-skeleton nb-skeleton--icon"></span>
            <span class="nb-skeleton-text">
              <span class="nb-skeleton nb-skeleton--title"></span>
              <span class="nb-skeleton nb-skeleton--body"></span>
              <span class="nb-skeleton nb-skeleton--body nb-skeleton--short"></span>
            </span>
          </div>
        }
      </div>
    } @else if (loadError) {
      <div class="nb-state">
        <i class="bx bx-error-circle" aria-hidden="true"></i>
        <span class="nb-state-title">Error loading notifications</span>
        <span class="nb-state-body">Couldn't load notifications. Tap to retry.</span>
        <button type="button" class="nb-primary" (click)="load()">Retry</button>
      </div>
    } @else if (groups.length === 0) {
      <div class="nb-state">
        <i class="bx bx-check-circle" aria-hidden="true"></i>
        <span class="nb-state-title">{{ emptyTitle }}</span>
        <span class="nb-state-body">{{ emptyMessage }}</span>
        @if (selectedFilter !== filters[0]) {
          <button type="button" class="nb-primary" (click)="showAll()">Show all</button>
        } @else {
          <a class="nb-ghost" routerLink="/main/notifications/preferences">
            Notification settings
          </a>
        }
      </div>
    } @else {
      <div class="nb-list" (scroll)="onScroll($event)">
        @for (group of groups; track group.label) {
          <div class="nb-day">{{ group.label }}</div>
          @for (row of group.rows; track row.notification.notification_id) {
            <button
              type="button"
              class="nb-row"
              [class.nb-row--unread]="!row.notification.is_read"
              [class.nb-row--alert]="row.isAlert && !row.notification.is_read"
              [class.nb-row--selected]="isSelected(row.notification)"
              (click)="open(row.notification)"
            >
              <span class="nb-cat-icon" [class.nb-cat-icon--alert]="row.isAlert">
                <i class="bx" [ngClass]="row.category.icon" aria-hidden="true"></i>
              </span>
              <span class="nb-message">
                <span class="nb-row-title">{{ row.notification.title }}</span>
                @if (row.notification.body) {
                  <span class="nb-row-body">{{ row.notification.body }}</span>
                }
              </span>
              <span class="nb-status">
                <span class="nb-cat">{{ row.category.label }}</span>
                <span class="nb-time">{{ row.time }}</span>
                @if (!row.notification.is_read) {
                  <span
                    class="nb-dot"
                    [class.nb-dot--alert]="row.isAlert"
                    aria-label="Unread"
                  ></span>
                }
              </span>
            </button>
          }
        }

        @if (loadingMore) {
          <div class="nb-foot">
            <span class="nb-spinner" aria-hidden="true"></span>
            <span>Loading more notifications…</span>
          </div>
        } @else if (loadMoreError) {
          <div class="nb-foot">
            <span>More notifications could not be loaded.</span>
            <button type="button" class="nb-retry" (click)="loadMore()">Retry</button>
          </div>
        }
      </div>
    }
  </div>

  <!-- Detail rail -->
  @if (selected) {
    <aside class="nb-detail" aria-label="Notification details">
      <div class="nb-detail-head">
        <span class="nb-detail-heading">Notification details</span>
        <button type="button" class="nb-icon-btn" aria-label="Close" (click)="closeDetail()">
          <i class="bx bx-x-circle" aria-hidden="true"></i>
        </button>
      </div>
      <div class="nb-detail-body">
        @if (selectedCategory) {
          <span class="nb-badge">{{ selectedCategory.label }}</span>
        }
        <span class="nb-detail-title">{{ selected.title }}</span>
        @if (selected.body) {
          <p class="nb-detail-text">{{ selected.body }}</p>
        }
        <span class="nb-detail-time">{{ selectedMoment }}</span>
      </div>
      <div class="nb-detail-actions">
        @if (selectedActionLabel) {
          <button type="button" class="nb-primary nb-block" (click)="openRoute()">
            {{ selectedActionLabel }}
          </button>
        }
        <button type="button" class="nb-ghost nb-block" (click)="toggleRead()">
          {{ selected.is_read ? 'Mark unread' : 'Mark as read' }}
        </button>
      </div>
    </aside>
  }
</div>
